<template>
  <div v-show="false">
    <component :is="layoutType"></component>
  </div>
</template>
<script>
import Vue from 'vue';
import { baseComponents, componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'AntiLeak',
  mixins: [componentBaseMixin],
  components: {},
  data() {
    return {
      layoutType: 'c-page-h5',
    };
  },
  computed: {
    canvasStyle() {
      return {
        background: '#ffffff',
      };
    },
  },
  async created() {
    await this.$login.initLogin();
    this.$store.dispatch('checkLogin');
    this.layoutType = Vue.prototype.$actInfo.layout_type;
    this.$store.commit('UPDATE_ACTINFO', Vue.prototype.$actInfo);
    Vue.prototype.$storeInstance = this.$store;
    this.$onLogined(async () => {
      console.log('登录成功');
      const { ret, data = {} } = await this.flowRequest({
        flowId: 186051,
        actId: Vue.prototype.$actInfo.activity_id,
      });
      const { ret: resRet } = data;
      if (resRet === 42001 || ret === 42001) {
        return this.$alert('当前用户不在白名单内！');
      }
      this.changelayoutType();
      this.$eventBus.$emit('ceiba:custom:events:close-user-login-popup');
    });
    this.initialize();
  },

  methods: {
    async initialize() {
      // 判断是否登录
      if (!this.isLogin) {
        baseComponents.userLoginComponent.showUserLoginPopup({
          imposeLoginType: 0,
          needWXLogin: false,
        });
      }
    },
    changelayoutType() {
      this.$emit('changelayoutType');
    },
  },
};
</script>

<style></style>
